import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "form-group relative",
  style: {"cursor":"pointer"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Countries", -1)
const _hoisted_3 = { class: "form-group relative d-flex flex-row align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "country-item" }
const _hoisted_6 = {
  key: 0,
  class: "form-group"
}
const _hoisted_7 = {
  key: 0,
  class: "form-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          class: "w-100 vs__multiple-block-statistics",
          value: $props.modelValue,
          options: $data.countries,
          label: "name",
          autocomplete: "off",
          multiple: "",
          placeholder: "Search for countries",
          "onOption:selected": _cache[0] || (_cache[0] = ($event: any) => ($options.updateModel($event))),
          "onOption:deselected": $options.deselectCountry,
          onSearch: $options.searchCountry
        }, {
          option: _withCtx((option) => [
            _createTextVNode("[" + _toDisplayString(option.code2) + "] " + _toDisplayString(option.name), 1)
          ]),
          "selected-option": _withCtx((option) => [
            _createTextVNode("[" + _toDisplayString(option.code2) + "] " + _toDisplayString(option.name), 1)
          ]),
          _: 1
        }, 8, ["value", "options", "onOption:deselected", "onSearch"])
      ])
    ]),
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.modelValue, (c) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_5, [
        ($data.regions[c.code2])
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("label", null, "[" + _toDisplayString(c.code2) + "] " + _toDisplayString(c.name) + " - Regions", 1),
              _createVNode(_component_v_select, {
                class: "w-100 vs__multiple-block-statistics",
                modelValue: c.regions,
                "onUpdate:modelValue": ($event: any) => ((c.regions) = $event),
                options: $data.regions[c.code2],
                label: "name",
                autocomplete: "off",
                multiple: "",
                placeholder: "Search for regions",
                "onOption:selected": _cache[1] || (_cache[1] = ($event: any) => ($options.updateRegionModel($event))),
                onSearch: (v) => $options.searchRegions(v, $data.regions[c.code2], c)
              }, {
                option: _withCtx((option) => [
                  _createTextVNode("[" + _toDisplayString(option.id) + "] " + _toDisplayString(option.name), 1)
                ]),
                "selected-option": _withCtx((option) => [
                  _createTextVNode("[" + _toDisplayString(option.id) + "] " + _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onSearch"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.regions, (r) => {
          return (_openBlock(), _createElementBlock("div", null, [
            ($data.cities[r.id])
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("label", null, "[" + _toDisplayString(r.id) + "] " + _toDisplayString(r.name) + " - Cities", 1),
                  _createVNode(_component_v_select, {
                    class: "w-100 vs__multiple-block-statistics",
                    modelValue: r.cities,
                    "onUpdate:modelValue": ($event: any) => ((r.cities) = $event),
                    options: $data.cities[r.id],
                    label: "name",
                    autocomplete: "off",
                    multiple: "",
                    placeholder: "Search for cities",
                    "onOption:selected": _cache[2] || (_cache[2] = ($event: any) => ($options.updateCityModel($event))),
                    onSearch: (v) => $options.searchCities(v, $data.cities[r.id], r)
                  }, {
                    option: _withCtx((option) => [
                      _createTextVNode("[" + _toDisplayString(option.id) + "] " + _toDisplayString(option.name), 1)
                    ]),
                    "selected-option": _withCtx((option) => [
                      _createTextVNode("[" + _toDisplayString(option.id) + "] " + _toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onSearch"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ]))
    }), 256))
  ]))
}